export const LOUVER_ANGLES = [15, 30, 45, 60].map(angle => ({ id: angle }))
